import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registerActions from './actions/';

class PaymentError extends Component {
    componentDidMount() {
        this.props.setStep('PAYMENT_ERROR');
    }

    post(path, params, method) {
        method = method || 'post'; // Set method to post by default if not specified.

        // The rest of this code assumes you are not using a library.
        // It can be made less wordy if you use one.
        let form = document.createElement('form');
        form.setAttribute('method', method);
        form.setAttribute('action', path);

        for (let key in params) {
            if (params.hasOwnProperty(key)) {
                let hiddenField = document.createElement('input');
                hiddenField.setAttribute('type', 'hidden');
                hiddenField.setAttribute('name', key);
                hiddenField.setAttribute('value', params[key]);

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
    }

    requestPaymentUrl() {
        this.props.history.push('/register/redirect-payment');
    }

    render() {
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <div className="thank-you__container">
                        <div className="thank-you__info">
                            <p>{window.VULOG_TRANSLATE('payment_error')}</p>
                            <div>
                                <button
                                    onClick={() => {
                                        this.requestPaymentUrl();
                                    }}
                                    className="btn btn-primary btn-block ml-auto mr-auto"
                                >
                                    {window.VULOG_TRANSLATE('retry_payment')}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/*<div className="d-flex flex-row mt-auto mb-1-5rem">*/}

                    {/*<button className="btn btn-primary btn-block ml-auto mr-auto">CLOSE</button>*/}

                    {/*</div>      */}
                </div>
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

function mapDispatchToProps(dispatch) {
    return bindActionCreators(registerActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentError);
